import { useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { getPoliciesAPI, postCostObjectsAPI } from '@/api/customerApi'
import Button from '@/components/form/Button'
import RadioButton from '@/components/form/RadioButton'
import ReactSelect from '@/components/form/ReactSelect'
import { Translation } from '@/components/i18n/Translation'
import LoaderCircle from '@/components/util/LoaderCircle'
import { closePopup, setApiErrorPopup } from '@/ducks/popupReducer'
import { fetchSubscriptionOrder, getSubscriptionOrder } from '@/ducks/subscriptionOrderReducer'
import { useMountEffect } from '@/hooks/mounting-hooks'

import './create-cost-object-form.scss'

const CreateCostObjectForm = () => {
  const dispatch = useDispatch()
  const {
    id,
    customer_id,
    code,
    user,
    department_id,
    employee_number,
    email,
    device_policy_id,
    salary_deduction_profile_id,
  } = useSelector(getSubscriptionOrder)

  const [isLoading, setIsLoading] = useState(true)

  const [devicePolicies, setDevicePolicies] = useState([])
  const [devicePolicyId, setDevicePolicyId] = useState(device_policy_id)

  const [telePolicies, setTelePolicies] = useState([])
  const [telePolicyId, setTelePolicyId] = useState(salary_deduction_profile_id)

  const [isFree, setIsFree] = useState(true)

  useMountEffect(() => {
    const loadPolicies = async () => {
      setIsLoading(true)

      const policies = await getPoliciesAPI(customer_id)
      // @ts-ignore
      setDevicePolicies(policies.devicePolicies)
      // @ts-ignore
      setTelePolicies(policies.telePolicies)
      setIsLoading(false)
    }
    loadPolicies().then(() => {})
  })

  const postCostObject = async () => {
    setIsLoading(true)

    try {
      const payload = {
        code,
        name: user,
        devicePolicyId,
        telePolicyId,
        isFree,
        email,
        departmentId: department_id,
        employeeNumber: employee_number,
      }
      await postCostObjectsAPI({ customerId: customer_id, costObject: payload })
      // @ts-ignore
      dispatch(fetchSubscriptionOrder(id))
      dispatch(closePopup())
    } catch {
      dispatch(setApiErrorPopup('Could not create cost object'))
      setIsLoading(false)
    }
  }
  // @ts-ignore
  const onSubmit = e => {
    e.preventDefault()
    postCostObject().then(() => {})
  }

  const isformDisabled = telePolicyId === undefined || devicePolicyId === undefined
  // @ts-ignore
  const policyToOptions = policies => [
    {
      value: null,
      label: <Translation id="No policy" />,
    },
    // @ts-ignore
    ...policies.map(policy => ({
      value: policy.id,
      label: policy.name,
    })),
  ]

  return (
    <div className="create-cost-object-form">
      <h2>
        <Translation id="Create Cost Object" />
      </h2>

      <h4>
        {code} - {user}
      </h4>

      {isLoading ? (
        <LoaderCircle />
      ) : (
        <form onSubmit={onSubmit}>
          <div className="ce-type">
            <RadioButton
              label={<Translation id="Free" />}
              checked={isFree}
              onChange={() => setIsFree(true)}
            />

            <RadioButton
              label={<Translation id="Work" />}
              checked={!isFree}
              onChange={() => setIsFree(false)}
            />
          </div>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>
            <Translation id="Device policy" />
          </label>

          <ReactSelect
            options={policyToOptions(devicePolicies)}
            // @ts-ignore
            onChange={value => setDevicePolicyId(value)}
            value={devicePolicyId}
          />

          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>
            <Translation id="Tele policy" />
          </label>

          <ReactSelect
            options={policyToOptions(telePolicies)}
            // @ts-ignore
            onChange={value => setTelePolicyId(value)}
            value={telePolicyId}
          />

          <Button disabled={isformDisabled}>
            <Translation id="Create" />
          </Button>
        </form>
      )}
    </div>
  )
}

export default CreateCostObjectForm
